customElements.define(
  "sample-logic",
  class SampleLogic extends HTMLElement {
    constructor() {
      super();

      this.sampleLogics = [];
      this.flickity = null;
    }

    connectedCallback() {
      this.itemsContainer = this.querySelector(".js-sample-items");

      this.validateSampleLogics();

      document.addEventListener(
        "rebuy:cart.change",
        this.validateSampleLogics.bind(this)
      );
    }

    mapSampleScenarios(cartItems) {
      this.sampleLogics = window.sampleLogic
        .map((logic) => {
          if (logic.type === "sample_buy_x_get_y") {
            const validQty = cartItems
              .filter(
                (item) => item.variant_id === logic.scenario.buy_x_variant.id
              )
              .filter((item) => item.properties?._sample !== logic.id)
              .map((item) => item.quantity)
              .reduce((a, b) => a + b, 0);

            return {
              type: logic.type,
              id: logic.id,
              items: logic.scenario.get_y_items,
              quantity: logic.scenario.get_y_quantity,
              cartMessage: logic.scenario.cart_message,
              valid: validQty >= logic.scenario.required_quantity,
              requiredItem: logic.scenario.buy_x_variant,
            };
          }

          if (logic.type === "sample_by_number") {
            const validQty = cartItems
              .filter(
                (item) =>
                  !(logic?.scenario?.sku_to_exclude || []).includes(item.sku)
              )
              .filter((item) => item.properties?._sample !== logic.id)
              .map((item) => item.quantity)
              .reduce((a, b) => a + b, 0);

            return {
              type: logic.type,
              id: logic.id,
              items: logic.scenario.get_y_items,
              quantity: logic.scenario.get_y_quantity,
              cartMessage: logic.scenario.cart_message,
              valid: validQty >= logic.scenario.required_quantity,
            };
          }

          if (logic.type === "sample_by_amount") {
            const validAmount = cartItems
              .filter(
                (item) =>
                  !(logic?.scenario?.sku_to_exclude || []).includes(item.sku)
              )
              .map((item) => item.line_price)
              .reduce((a, b) => a + b, 0);

            return {
              type: logic.type,
              id: logic.id,
              items: logic.scenario.get_y_items,
              quantity: logic.scenario.get_y_quantity,
              cartMessage: logic.scenario.cart_message,
              valid: validAmount >= logic.scenario.required_cart_amount,
            };
          }
        })
        .filter((item) => !!item);
    }

    async validateSampleLogics() {
      const cartItems = window.Rebuy.Cart.items();

      // if (localStorage.getItem('sample-busy')) return;

      localStorage.setItem("sample-busy", true);

      this.mapSampleScenarios(cartItems);
      const samplesInCart = cartItems.some((item) => item.properties?._sample);

      const inEligibleItems = cartItems
        .filter((item) => !!item.properties?._sample)
        .filter((item) => {
          const logic = this.sampleLogics.find((e) => {
            return (
              e.id === item.properties?._sample &&
              e.items.map((el) => el.id).includes(item.variant_id)
            );
          });

          return !logic?.valid;
        });

      if (inEligibleItems.length > 0) {
        let updates = {};
        inEligibleItems.map((item) => (updates[item.key] = 0));

        await window.Rebuy.Cart.updateItem({ updates });
      }

      this.renderSnippet(samplesInCart);
    }

    renderSnippet(sampleInCart) {
      const html = this.sampleLogics
        .map((logic) => {
          const itemsById = Object.groupBy(
            logic.items,
            ({ product_id }) => product_id
          );
          let quantity = logic.quantity;
          let cartMessage = logic.cartMessage;

          if (logic.type === "sample_buy_x_get_y") {
            const requiredItemsInCart = window.Rebuy.Cart.items()
              .filter((item) => item.variant_id === logic.requiredItem.id)
              .map((item) => item.quantity)
              .reduce((a, b) => a + b, 0);

            quantity = Math.min(requiredItemsInCart, quantity);
          }

          return Object.keys(itemsById)
            .map((productId) => {
              const items = itemsById[productId];
              const defaultItem = items[0];

              const cartItem = window.Rebuy.Cart.items().find((lineItem) => {
                return (
                  +lineItem.properties?._sample === +logic.id &&
                  lineItem.variant_id === defaultItem.id
                );
              });

              return `
          <sample-item>
            <div class="sample-item ${
              logic.valid ? "" : "disabled"
            }" data-id="${defaultItem.id}">
              <div class="sample-item__media">
                <div class=" media media--square media--image-contain">
                  <img src="${defaultItem.image}" class="js-thumbnail-image">
                </div>
              </div>
              <div class="sample-item__info">
                <div>
                  <h4 class="sample-item__title">${
                    defaultItem.product_title
                  }</h4>
                  <p class="sample-item__subtitle js-variant-title">${
                    defaultItem.variant_title
                  }</p>
                </div>
                ${
                  items.length > 1
                    ? `<ul class="sample-item__variants">
                    ${items
                      .map((item) => {
                        return `<li>
                        <button
                          type="button"
                          class="sample-item-variant ${
                            !!item.color_swatch_fallback
                              ? "sample-item-swatch"
                              : ""
                          } ${
                          item.id === defaultItem.id ? "selected" : ""
                        } js-variant"
                          style="${item.swatch_style}"
                          data-id="${item.id}"
                          data-sample-id="${logic.id}"
                          data-image="${item.image}"
                          data-title="${item.variant_title}"
                        >${item.title}</button>
                      </li>`;
                      })
                      .join("")}
                  </ul>
                  `
                    : ""
                }
                <sample-item-action>
                  ${
                    logic.valid
                      ? `<button
                      class="sample-item__add js-sample-action ${
                        !!cartItem ? "" : "js-add"
                      }"
                      data-id="${defaultItem.id}"
                      data-sample-id="${logic.id}"
                      data-type="${logic.type}"
                      data-quantity="${quantity}"
                      type="button"
                    >${!!cartItem ? "Added" : "Add"}</button>`
                      : `<p class="caption-large light">${cartMessage}</p>`
                  }
                </sample-item-action>
              </div>
            </div>
          </sample-item>
        `;
            })
            .join("");
        })
        .join("");

      const sampleItemsCount = this.sampleLogics
        .map((logic) => logic.items.length)
        .reduce((a, b) => a + b, 0);

      this.classList[sampleItemsCount === 0 ? "add" : "remove"]("hidden");

      if (sampleInCart) this.classList.add("hidden");

      if (!!this.flickity) {
        this.flickity.destroy();
      }

      this.itemsContainer.innerHTML = html;

      this.flickity = new Flickity(this.itemsContainer, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: sampleItemsCount > 1,
      });

      localStorage.removeItem("sample-busy");

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    }
  }
);

if (!customElements.get("sample-item")) {
  customElements.define(
    "sample-item",
    class SampleItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.thumbnailImage = this.querySelector(".js-thumbnail-image");
        this.variantButtons = this.querySelectorAll(".js-variant");
        this.sampleAction = this.querySelector("sample-item-action");

        this.variantButtons.forEach((button) =>
          button.addEventListener("click", this.handleSwatchClick.bind(this))
        );
      }

      handleSwatchClick(e) {
        const button = e.target.closest(".js-variant");

        const { id, image, title, sampleId } = button.dataset;

        this.thumbnailImage.setAttribute("src", image);
        this.querySelector(".js-variant-title").innerHTML = title;

        this.variantButtons.forEach((el) =>
          el.classList[el.dataset.id === id ? "add" : "remove"]("selected")
        );

        if (!!this.querySelector(".js-sample-action")) {
          this.querySelector(".js-sample-action").setAttribute("data-id", id);
        }

        const cartItem = window.Rebuy.Cart.items().find((lineItem) => {
          return (
            +lineItem.properties?._sample === +sampleId &&
            +lineItem.variant_id === +id
          );
        });

        if (!!cartItem) {
          this.querySelector(".js-sample-action").setAttribute("disabled", "");
          this.querySelector(".js-sample-action").innerHTML = "Added";
        } else {
          this.querySelector(".js-sample-action").removeAttribute("disabled");
          this.querySelector(".js-sample-action").innerHTML = "Add";
        }
      }
    }
  );
}

if (!customElements.get("sample-item-action")) {
  customElements.define(
    "sample-item-action",
    class SampleItemAction extends HTMLElement {
      constructor() {
        super();

        this.addButton = this.querySelector(".js-add");
      }

      connectedCallback() {
        this.addButton?.addEventListener("click", this.onAddClick.bind(this));
      }

      async onAddClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const { id, type, quantity, sampleId } = this.addButton.dataset;

        this.addButton.setAttribute("disabled", true);
        this.addButton.innerHTML = "Adding";

        const cartItems = window.Rebuy.Cart.items();
        const sampleInCart = cartItems.filter(
          (item) => item?.properties?._sample === sampleId
        );

        // Logic for Sample total Qty
        if (sampleInCart.length >= parseInt(quantity)) {
          let updates = {};
          sampleInCart.slice(-1).map((item) => (updates[item.key] = 0));

          await window.Rebuy.Cart.updateItem({ updates });
        }

        await window.Rebuy.Cart.addItem({
          id: id,
          quantity: 1,
          properties: {
            _sample: sampleId,
            _sample_type: type,
          },
        });

        this.addButton.removeAttribute("disabled");
        this.addButton.innerHTML = "Added";
      }
    }
  );
}
